// extracted by mini-css-extract-plugin
export default {"button":"LoadMore_button__vuw8B"};